import {
  CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST,
  CONTRACT_PROGRESS_SIGNATURE_SELECT,
} from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';
import SignatureFieldType from '@app/store/contract-progress/SignatureFieldType';

interface ContractProgressFieldSelectedSignature {
  id: string;
  s3Key: string;
  type: SignatureFieldType;
  url: string;
}

export type ContractProgressFieldSelectedSignatureState =
  ContractProgressFieldSelectedSignature | null;

const initialState: ContractProgressFieldSelectedSignatureState = null;

export default function reducer(
  state: ContractProgressFieldSelectedSignatureState = initialState,
  action: ContractProgressAction
): ContractProgressFieldSelectedSignatureState {
  switch (action.type) {
    case CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST:
      return initialState;
    case CONTRACT_PROGRESS_SIGNATURE_SELECT: {
      const { id, s3Key, type, url } = action.payload;
      return {
        id,
        s3Key,
        type,
        url,
      };
    }
    default:
      return state;
  }
}
